export const COMMERCIAL_TYPES = {
  NON_COMMERCIAL: 'NON_COMMERCIAL',
  COMMERCIAL: 'COMMERCIAL',
  RIDE_SHARING: 'RIDE_SHARING',
};

export const LENDER_TYPES = {
  ALLY: 'Ally',
  AMERICREDIT: 'Americredit',
  CAPITALONE: 'Capital1',
  CHASE: 'Chase',
  RELIABLECREDIT: 'ORGAP',
  CAC: 'CAC',
  WELLS_FARGO: 'WellsFargo',
  TD_BANK: 'TDBank',
  OTHER: 'Other',
};

export const VEHICLE_CONDITION_TYPES = {
  NEW: 'NEW',
  USED: 'USED',
};

export const VEHICLE_CONDITION_OPTIONS = [
  {
    value: VEHICLE_CONDITION_TYPES.USED,
    label: 'Used',
  },
  {
    value: VEHICLE_CONDITION_TYPES.NEW,
    label: 'New',
  },
];

export const RELIABLE_CREDIT_ASSOCIATION_OPTIONS = [
  {
    label: 'Reliable Credit Association',
    value: 'AZRCA',
  },
  {
    label: 'Other',
    value: 'OTHER',
  },
];

export const LENDER_TYPE_OPTIONS_ALL = {
  CA: [
    {
      label: 'Americredit',
      value: 'Americredit',
    },
    {
      label: 'Capital One',
      value: 'Capital1',
    },
    {
      label: 'Chase',
      value: 'Chase',
    },
    {
      label: 'Credit Acceptance Corporation (CAC)',
      value: 'CAC',
    },
    {
      label: 'Wells Fargo',
      value: 'WellsFargo',
    },
    {
      label: 'TD Bank',
      value: 'TDBank',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  OR: [
    {
      label: 'Americredit',
      value: 'Americredit',
    },
    {
      label: 'Capital One',
      value: 'Capital1',
    },
    {
      label: 'Chase',
      value: 'Chase',
    },
    {
      label: 'Reliable Credit (RCA) or Credit Union',
      value: 'ORGAP',
    },
    {
      label: 'Wells Fargo',
      value: 'WellsFargo',
    },
    {
      label: 'TD Bank',
      value: 'TDBank',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  SD: [
    {
      label: 'Ally',
      value: 'Ally',
    },
    {
      label: 'Americredit',
      value: 'Americredit',
    },
    {
      label: 'Capital One',
      value: 'Capital1',
    },
    {
      label: 'Chase',
      value: 'Chase',
    },
    {
      label: 'Credit Acceptance Corporation (CAC)',
      value: 'CAC',
    },
    {
      label: 'Wells Fargo',
      value: 'WellsFargo',
    },
    {
      label: 'TD Bank',
      value: 'TDBank',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  WY: [
    {
      label: 'Ally',
      value: 'Ally',
    },
    {
      label: 'Americredit',
      value: 'Americredit',
    },
    {
      label: 'Capital One',
      value: 'Capital1',
    },
    {
      label: 'Chase',
      value: 'Chase',
    },
    {
      label: 'Wells Fargo',
      value: 'WellsFargo',
    },
    {
      label: 'TD Bank',
      value: 'TDBank',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  Other: [
    {
      label: 'Americredit',
      value: 'Americredit',
    },
    {
      label: 'Capital One',
      value: 'Capital1',
    },
    {
      label: 'Chase',
      value: 'Chase',
    },
    {
      label: 'Wells Fargo',
      value: 'WellsFargo',
    },
    {
      label: 'TD Bank',
      value: 'TDBank',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
};

export const BHPH_OPTIONS = ['No', 'Yes'];
